import { UseGqlMutationCallbacks, useMutationOptionsWithInvalidation } from '@alice-financial/api'
import { QueryKey, useMutation } from '@tanstack/react-query'
import { UpdateBillingConfigMutation, useUpdateBillingConfigMutation , UpdateBillingConfigInput } from '@alice-financial/alice-sdk'

type SetUnifiedBillingVariables = Required<Pick<UpdateBillingConfigInput, 'orgId' | 'hasUnifiedBilling'>>
type UseSetUnifiedBillingMutationOptions = UseGqlMutationCallbacks<
  UpdateBillingConfigMutation,
  SetUnifiedBillingVariables
>

export const useSetUnifiedBilling = (
  invalidationKeys: Array<QueryKey>,
  mutationOptions?: UseSetUnifiedBillingMutationOptions
) => {
  const { mutateAsync: updateBillingConfig } = useUpdateBillingConfigMutation()
  const optionsWithInvalidation = useMutationOptionsWithInvalidation(mutationOptions, invalidationKeys)
  return useMutation(
    ['setUnifiedBilling'],
    (input) => updateBillingConfig({ input }),
    optionsWithInvalidation
  )
}
